import { CSSProperties, memo } from 'react';
import {
  IconAdjustmentsHorizontal,
  IconAlertCircle,
  IconAlertTriangle,
  IconArchive,
  IconArchiveFilled,
  IconArrowUp,
  IconArrowUpRight,
  IconArticle,
  IconBadgeCc,
  IconBell,
  IconBellCheck,
  IconBellOff,
  IconBold,
  IconBrain,
  IconBrandFacebook,
  IconBrandGmail,
  IconBrandGoogle,
  IconBrandGoogleDrive,
  IconBrandInstagram,
  IconBrandLine,
  IconBrandLinkedin,
  IconBrandSlack,
  IconBrandTrello,
  IconBriefcase,
  IconBrush,
  IconBuilding,
  IconCalendar,
  IconCancel,
  IconCarouselHorizontal,
  IconChartBar,
  IconCheck,
  IconCheckbox,
  IconChevronDown,
  IconChevronLeft,
  IconChevronRight,
  IconChevronsLeft,
  IconChevronsRight,
  IconChevronUp,
  IconCircle,
  IconCircleCheckFilled,
  IconCircleFilled,
  IconCircleOff,
  IconCircleXFilled,
  IconClock,
  IconClockShare,
  IconContract,
  IconCopy,
  IconCornerUpLeft,
  IconCurrencyDollar,
  IconDots,
  IconDownload,
  IconEdit,
  IconExternalLink,
  IconEye,
  IconEyeEdit,
  IconEyeOff,
  IconFile,
  IconFileMusic,
  IconFileTypeCsv,
  IconFileTypeDoc,
  IconFileTypePdf,
  IconFileTypePpt,
  IconFileTypeTxt,
  IconFileTypeXls,
  IconFileTypeZip,
  IconFilter2,
  IconFolder,
  IconGripVertical,
  IconH1,
  IconH2,
  IconH3,
  IconH4,
  IconH5,
  IconH6,
  IconHeart,
  IconHistory,
  IconHistoryToggle,
  IconHome,
  IconInfoCircle,
  IconItalic,
  IconKey,
  IconLanguage,
  IconLayoutGrid,
  IconLayoutSidebar,
  IconLayoutSidebarFilled,
  IconLayoutSidebarRight,
  IconLayoutSidebarRightFilled,
  IconLetterCase,
  IconLink,
  IconList,
  IconListNumbers,
  IconLock,
  IconLogout,
  IconMail,
  IconMessageCircle,
  IconMicrophone,
  IconMicrophoneOff,
  IconMoodPlus,
  IconMovie,
  IconNotes,
  IconPaperclip,
  IconPencil,
  IconPencilCog,
  IconPencilPlus,
  IconPhoto,
  IconPlayerPlay,
  IconPlayerStop,
  IconPlus,
  IconPointFilled,
  IconRefresh,
  IconRepeat,
  IconSearch,
  IconSend,
  IconSettings,
  IconSocial,
  IconSparkles,
  IconSpeakerphone,
  IconSquare,
  IconSquareCheck,
  IconStar,
  IconStarFilled,
  IconStrikethrough,
  IconTemplate,
  IconThumbUp,
  IconThumbUpFilled,
  IconTrash,
  IconUnderline,
  IconUser,
  IconUserCircle,
  IconUserOff,
  IconUsers,
  IconWand,
  IconWebhook,
  IconWorld,
  IconX,
  IconProps as TablerIconProps,
} from '@tabler/icons-react';
import { Center, CenterProps } from '@mantine/core';
import classes from './Icon.module.css';

const ICON_MAP = {
  adjustments: IconAdjustmentsHorizontal,
  calendar: IconCalendar,
  search: IconSearch,
  chevronDown: IconChevronDown,
  chevronUp: IconChevronUp,
  chevronRight: IconChevronRight,
  chevronLeft: IconChevronLeft,
  home: IconHome,
  list: IconList,
  bell: IconBell,
  layoutGrid: IconLayoutGrid,
  layoutSidebar: IconLayoutSidebar,
  layoutSidebarFilled: IconLayoutSidebarFilled,
  layoutSidebarRight: IconLayoutSidebarRight,
  layoutSidebarRightFilled: IconLayoutSidebarRightFilled,
  settings: IconSettings,
  file: IconFile,
  user: IconUser,
  users: IconUsers,
  building: IconBuilding,
  briefcase: IconBriefcase,
  template: IconTemplate,
  userCircle: IconUserCircle,
  userOff: IconUserOff,
  logout: IconLogout,
  plus: IconPlus,
  x: IconX,
  check: IconCheck,
  sparkles: IconSparkles,
  refresh: IconRefresh,
  edit: IconEdit,
  trash: IconTrash,
  checkbox: IconCheckbox,
  contract: IconContract,
  alertCircle: IconAlertCircle,
  gripVertical: IconGripVertical,
  download: IconDownload,
  circle: IconCircle,
  pointFilled: IconPointFilled,
  pencil: IconPencil,
  dots: IconDots,
  wand: IconWand,
  chevronsRight: IconChevronsRight,
  chevronsLeft: IconChevronsLeft,
  archive: IconArchive,
  social: IconSocial,
  notes: IconNotes,
  paperclip: IconPaperclip,
  eye: IconEye,
  thumbUp: IconThumbUp,
  thumbUpFilled: IconThumbUpFilled,
  play: IconPlayerPlay,
  archiveFilled: IconArchiveFilled,
  alertTriangle: IconAlertTriangle,
  clock: IconClock,
  eyeOff: IconEyeOff,
  history: IconHistory,
  world: IconWorld,
  link: IconLink,
  instagram: IconBrandInstagram,
  facebook: IconBrandFacebook,
  linkedin: IconBrandLinkedin,
  photo: IconPhoto,
  brain: IconBrain,
  pencilPlus: IconPencilPlus,
  pencilCog: IconPencilCog,
  listNumbers: IconListNumbers,
  letterCase: IconLetterCase,
  h1: IconH1,
  h2: IconH2,
  h3: IconH3,
  h4: IconH4,
  h5: IconH5,
  h6: IconH6,
  bold: IconBold,
  italic: IconItalic,
  underline: IconUnderline,
  strikethrough: IconStrikethrough,
  arrowUp: IconArrowUp,
  playerStop: IconPlayerStop,
  brush: IconBrush,
  brandInstagram: IconBrandInstagram,
  brandFacebook: IconBrandFacebook,
  brandLinkedin: IconBrandLinkedin,
  circleFilled: IconCircleFilled,
  circleXFilled: IconCircleXFilled,
  circleCheckFilled: IconCircleCheckFilled,
  send: IconSend,
  brandLine: IconBrandLine,
  moodPlus: IconMoodPlus,
  externalLink: IconExternalLink,
  brandTrello: IconBrandTrello,
  brandGoogle: IconBrandGoogle,
  arrowUpRight: IconArrowUpRight,
  mail: IconMail,
  language: IconLanguage,
  heart: IconHeart,
  star: IconStar,
  starFilled: IconStarFilled,
  messageCircle: IconMessageCircle,
  microphone: IconMicrophone,
  microphoneOff: IconMicrophoneOff,
  bellCheck: IconBellCheck,
  brandGmail: IconBrandGmail,
  webhook: IconWebhook,
  key: IconKey,
  brandGoogleDrive: IconBrandGoogleDrive,
  badgeCc: IconBadgeCc,
  brandSlack: IconBrandSlack,
  chartBar: IconChartBar,
  lock: IconLock,
  folder: IconFolder,
  carouselHorizontal: IconCarouselHorizontal,
  movie: IconMovie,
  historyToggle: IconHistoryToggle,
  bellOff: IconBellOff,
  square: IconSquare,
  squareCheck: IconSquareCheck,
  speakerphone: IconSpeakerphone,
  cornerUpLeft: IconCornerUpLeft,
  filter2: IconFilter2,
  circleOff: IconCircleOff,
  eyeEdit: IconEyeEdit,
  infoCircle: IconInfoCircle,
  cancel: IconCancel,
  clockShare: IconClockShare,
  currencyDollar: IconCurrencyDollar,
  copy: IconCopy,
  repeat: IconRepeat,
  article: IconArticle,
  fileTypePdf: IconFileTypePdf,
  fileTypeDoc: IconFileTypeDoc,
  fileTypeXls: IconFileTypeXls,
  fileTypeCsv: IconFileTypeCsv,
  fileTypePpt: IconFileTypePpt,
  fileTypeZip: IconFileTypeZip,
  fileTypeTxt: IconFileTypeTxt,
  fileMusic: IconFileMusic,
};

export type IconName = keyof typeof ICON_MAP;

const ICON_SIZE_MAP: Record<string, number> = {
  md: 16,
  lg: 20,
};

export type IconProps = TablerIconProps & {
  name: IconName;
  size?: keyof typeof ICON_SIZE_MAP | number;
  p?: CenterProps['p'];
};

export const Icon = memo(
  ({
    name,
    className,
    style,
    size,
    p = 2,
    color = 'var(--mantine-color-text)',
    ...props
  }: IconProps) => {
    const IconComponent = ICON_MAP[name];

    if (!IconComponent) {
      console.error(`Icon ${name} not found`);
      return null;
    }

    const iconSize =
      typeof size === 'string' && size in ICON_SIZE_MAP
        ? ICON_SIZE_MAP[size]
        : typeof size === 'number'
          ? size
          : 16;

    return (
      <Center p={p}>
        <IconComponent
          className={`${classes.icon} ${name.endsWith('Filled') ? classes.filled : ''} ${className}`}
          style={{ ...(style ?? {}), '--icon-color': color } as CSSProperties}
          width={iconSize}
          height={iconSize}
          {...props}
        />
      </Center>
    );
  }
);
